import Confirm from './components/Confirm'

Confirm.install = (Vue, options) => {
  Vue.prototype.$confirm = new (Vue.extend(Confirm))({ propsData: options })
  Vue.confirm = Vue.prototype.$confim
}

export default Confirm